@if (noCard === false) {
  <portal-card>
    <ng-container header>
      <h2>{{ title | translate }}</h2>
    </ng-container>

    <ng-container [ngTemplateOutlet]="content" />
  </portal-card>
} @else {
  <ng-container [ngTemplateOutlet]="content" />
}

<ng-template #content>
  <portal-errors [errors]="error"></portal-errors>
  <div class="row">
    <div class="col-12">
      <h2>{{ 'export' | portalTranslate }}</h2>
      <div>
        <portal-file-download [url]="downloadUrl" btnClass="btn-outline-secondary"
          ><i class="far fa-arrow-to-bottom"></i>
          {{ 'phoneBook.title' | portalTranslate }}
        </portal-file-download>
        <portal-file-download class="ms-1" [url]="templateDownloadUrl" btnClass="btn-outline-secondary"
          ><i class="far fa-arrow-to-bottom"></i>
          {{ 'phoneBook.template' | portalTranslate }}
        </portal-file-download>
      </div>
    </div>
    <div class="col-12 mt-3">
      <h2>{{ 'import' | portalTranslate }}</h2>
      <div>
        <p>{{ 'phoneBook.import.steps.description' | portalTranslate }}</p>
        <div class="file-select d-inline">
          <portal-file-select
            [disabled]="uploadInProgress"
            (onFileChanged)="importFileChanged($event)"
            accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet, application/vnd.ms-excel"
            btnClass="btn-outline-secondary"
          >
            {{ 'choose.file' | translate }}
          </portal-file-select>
        </div>
      </div>
      @if (importFile) {
        <div>
          <p>
            <span>{{ 'file' | translate }}: </span>
            <code>{{ importFile.name }}</code>
          </p>
          <p>
            <span>{{ 'phoneBook.import.should.replace.existing' | translate }}</span>
            <portal-switch-toggle
              class="d-block switch-label-yes-no"
              [disabled]="uploadInProgress"
              [value]="replaceOldContacts"
              (onValueChanged)="replaceOldContacts = !replaceOldContacts"
              labelActive="switch.yes"
              labelInactive="switch.no"
            ></portal-switch-toggle>
          </p>
          <p>
            <portal-progress-button
              [disabled]="uploadInProgress"
              [progress]="fileUploadProgress"
              (clicked)="importPhoneBookClicked()"
              btnClass="btn-primary"
            >
              <i class="far fa-arrow-from-bottom"></i> {{ 'import.execute' | translate }}
            </portal-progress-button>
          </p>
          <!-- Result -->
          @if (importedDataDefined) {
            <div>
              @if (importedData; as data) {
                <div>
                  <div>
                    <table class="table table-sm">
                      <tbody>
                        <tr class="table-info">
                          <td>
                            <strong>
                              {{ data.totalNumberOfProcessedItems }} {{ 'import.processed' | translate }}
                            </strong>
                          </td>
                        </tr>
                        <tr class="table-success" [hidden]="data.imported.length == 0">
                          <td>{{ data.imported.length }} {{ 'import.imported' | translate }}</td>
                        </tr>
                        <tr class="table-warning" [hidden]="data.warnings.length == 0">
                          <td>{{ data.warnings.length }} {{ 'import.ignored' | translate }}</td>
                        </tr>
                        <tr class="table-danger" [hidden]="data.errors.length == 0">
                          <td>{{ data.errors.length }} {{ 'import.erroneous' | translate }}</td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                  @if (data.warnings.length > 0) {
                    <div>
                      <div class="card card-warning">
                        <div class="card-header text-white text-bg-warning">
                          <span>{{ 'phoneBook.import.contacts.with.warnings' | portalTranslate }}</span>
                          <span
                            class="float-end g-cursor-pointer"
                            (click)="collapseWarnings = !collapseWarnings"
                          >
                            <span>
                              {{ (collapseWarnings ? 'general.show' : 'general.hide') | translate }}
                            </span>
                            <span class="badge text-bg rounded-pill text-bg-light ms-1">
                              {{ data.warnings.length }}
                            </span></span
                          >
                        </div>
                        <div class="card-body p-0 table-responsive-sm" [hidden]="collapseWarnings">
                          <table class="table table-bordered table-sm mb-0">
                            <thead>
                              <tr>
                                <th>{{ 'import.row' | translate }} #</th>
                                <th>{{ 'phoneBook.firstName' | translate }}</th>
                                <th>{{ 'phoneBook.lastName' | translate }}</th>
                                <th>{{ 'phoneBook.company' | translate }}</th>
                                <th>{{ 'phoneBook.businessPhone' | translate }}</th>
                                <th>{{ 'cause' | translate }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (importItem of data.warnings; track importItem) {
                                <tr>
                                  <td>{{ importItem.rawInput.rowNum }}</td>
                                  <td>{{ importItem.rawInput.firstName }}</td>
                                  <td>{{ importItem.rawInput.lastName }}</td>
                                  <td>{{ importItem.rawInput.company }}</td>
                                  <td>{{ importItem.rawInput.businessPhone }}</td>
                                  <td>{{ importItem.status | translate }}</td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  }
                  @if (data.errors.length > 0) {
                    <div>
                      <div class="card card-danger">
                        <div class="card-header text-white text-bg-danger">
                          <span>{{ 'phoneBook.import.contacts.with.errors' | portalTranslate }}</span>
                          <span class="float-end g-cursor-pointer" (click)="collapseErrors = !collapseErrors">
                            <span>{{ (collapseErrors ? 'general.show' : 'general.hide') | translate }}</span>
                            <span class="badge rounded-pill text-bg-light ms-1">
                              {{ data.errors.length }}</span
                            >
                          </span>
                        </div>
                        <div class="card-body p-0 table-responsive-sm" [hidden]="collapseErrors">
                          <table class="table table-bordered table-sm mb-0">
                            <thead>
                              <tr>
                                <th>{{ 'import.row' | translate }} #</th>
                                <th>{{ 'phoneBook.firstName' | translate }}</th>
                                <th>{{ 'phoneBook.lastName' | translate }}</th>
                                <th>{{ 'phoneBook.company' | translate }}</th>
                                <th>{{ 'phoneBook.businessPhone' | translate }}</th>
                                <th>{{ 'error' | translate }}</th>
                                <th>{{ 'detail' | translate }}</th>
                              </tr>
                            </thead>
                            <tbody>
                              @for (importItem of data.errors; track importItem) {
                                <tr>
                                  <td>{{ importItem.rawInput.rowNum }}</td>
                                  <td>{{ importItem.rawInput.firstName }}</td>
                                  <td>{{ importItem.rawInput.lastName }}</td>
                                  <td>{{ importItem.rawInput.company }}</td>
                                  <td>{{ importItem.rawInput.businessPhone }}</td>
                                  <td>{{ importItem.error | translate }}</td>
                                  <td>
                                    @for (errData of importItem.errorData; track errData) {
                                      <div>
                                        <span>{{ errData.name }}</span> | <span>{{ errData.type }}</span> |
                                        <span>{{ errData.allowedValue }}</span>
                                      </div>
                                    }
                                  </td>
                                </tr>
                              }
                            </tbody>
                          </table>
                        </div>
                      </div>
                    </div>
                  }
                </div>
              }
            </div>
          }
        </div>
      }
    </div>
  </div>
</ng-template>
